const colors = {
  white: '#fff',
  black: '#000',
  primary: '#0088cc'
}

export default colors